import apiClient from '../config/api';

const permissionService = {
  /**
   * Get all permissions for the current tenant
   */
  getAllPermissions: async () => {
    const response = await apiClient.get('/permission');
    return response.data;
  },

  /**
   * Get permissions for a specific role
   */
  getPermissionsByRole: async (roleId) => {
    const response = await apiClient.get(`/permission/role/${roleId}`);
    return response.data;
  },

  /**
   * Assign permissions to a role
   */
  assignPermissionsToRole: async (roleId, permissionIds) => {
    const response = await apiClient.post(`/permission/role/${roleId}/assign`, {
      permissionIds,
    });
    return response.data;
  },

  /**
   * Remove permissions from a role
   */
  removePermissionsFromRole: async (roleId, permissionIds) => {
    const response = await apiClient.post(`/permission/delete/role/${roleId}/remove`, {
      data: { permissionIds },
    });
    return response.data;
  },

  /**
   * Set all permissions for a role (replaces existing)
   */
  setRolePermissions: async (roleId, permissionIds) => {
    const response = await apiClient.post(`/permission/role/${roleId}/set`, {
      permissionIds,
    });
    return response.data;
  },

  /**
   * Get permissions for a user
   */
  getUserPermissions: async (userId) => {
    const response = await apiClient.get(`/permission/user/${userId}`);
    return response.data;
  },

  /**
   * Seed default permissions (admin only)
   */
  seedPermissions: async () => {
    const response = await apiClient.post('/permission/seed');
    return response.data;
  },

  /**
   * Get full permission objects for a user (for management UI)
   */
  getUserPermissionsFull: async (userId) => {
    const response = await apiClient.get(`/permission/user/${userId}/full`);
    return response.data;
  },

  /**
   * Set all permissions for a user (replaces existing)
   */
  setUserPermissions: async (userId, permissionIds) => {
    const response = await apiClient.post(`/permission/user/${userId}/set`, {
      permissionIds,
    });
    return response.data;
  },
};

export default permissionService;

